if (!customElements.get('header-section')) {
  customElements.define(
    'header-section',
    class HeaderSection extends HTMLElement {
      private lastScrollPosition: number
      private isHeaderVisible: boolean
      private isAtTop: boolean
      private isScrollingDown: boolean | null
      private parentHeader: HTMLElement | null
      private hamburgerButton: HTMLElement | null
      private mobileMenu: HTMLElement | null
      private megaMenuDropdowns: NodeListOf<HTMLElement> | null

      constructor() {
        super()
        this.lastScrollPosition = window.scrollY
        this.isHeaderVisible = true
        this.isAtTop = true // Start at the top of the page
        this.isScrollingDown = null // No initial scroll direction
        this.parentHeader = this.closest('#shopify-section-header')
        this.hamburgerButton = this.querySelector('[data-hamburger-button]')
        this.mobileMenu = this.querySelector('[data-menu-mobile]')
        this.megaMenuDropdowns = this.querySelectorAll('[data-mega-menu-dropdown-el]')
      }

      handleScroll(): void {
        const currentScrollPosition = window.scrollY
        const isScrollingDown = currentScrollPosition > this.lastScrollPosition
        const isAtTop = currentScrollPosition === 0

        // Only run the logic if scroll direction or top state has changed
        if (isScrollingDown !== this.isScrollingDown || isAtTop !== this.isAtTop) {
          this.isScrollingDown = isScrollingDown
          this.isAtTop = isAtTop

          if (isAtTop && this.parentHeader) {
            // At the top of the page
            this.style.transform = 'translateY(0)'
            this.isHeaderVisible = true
          } else if (isScrollingDown && this.isHeaderVisible && this.parentHeader) {
            this.style.transform = 'translateY(-130%)'
            this.isHeaderVisible = false
          } else if (!isScrollingDown && !this.isHeaderVisible && this.parentHeader) {
            // Scrolling up
            this.style.transform = 'translateY(0)'
            this.isHeaderVisible = true
          }
        }

        // Adjust top position based on scroll position
        if (this.parentHeader) {
          const defaultTop = 0
          const announcementBarClosed = !document
            .querySelector('[data-announcement-bar-root]')
            ?.querySelector('[data-close-announcement]')
          const topOffset =
            announcementBarClosed && currentScrollPosition <= defaultTop
              ? -34
              : !announcementBarClosed && currentScrollPosition <= defaultTop
              ? defaultTop // top position with announcement bar
              : currentScrollPosition > defaultTop
              ? -34
              : defaultTop // scroll position

          this.parentHeader.style.top = `${topOffset}px`
        }

        this.lastScrollPosition = currentScrollPosition
      }

      handleHamburgerClick(): void {
        if (this.mobileMenu && this.hamburgerButton) {
          this.hamburgerButton.addEventListener('click', () => {
            this.mobileMenu?.classList.toggle('hidden')
            document.querySelector('body')?.classList.toggle('overflow-hidden')
          })
        }
      }

      handleMegaMenuHover(): void {
        if (this.megaMenuDropdowns) {
          this.megaMenuDropdowns.forEach((dropdown) => {
            dropdown.addEventListener('mouseenter', () => {
              document.body.classList.add('overflow-hidden')
            })
            dropdown.addEventListener('mouseleave', () => {
              document.body.classList.remove('overflow-hidden')
            })
          })
        }
      }

      init(): void {
        window.addEventListener('scroll', () => this.handleScroll())
        this.handleHamburgerClick()
        this.handleMegaMenuHover()
      }

      // Lifecycle callback when the element is connected to the DOM
      connectedCallback(): void {
        this.init()
      }
    },
  )
}
